import { IconLogout } from '@tabler/icons';

const dashboard = {
  id: 'logout',
  title: 'Logout',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Logout',
      type: 'item',
      url: '/logout/default',
      icon: IconLogout,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
